import { Button, Input, Popconfirm, Table } from "antd";
import { Plus, Trash } from "lucide-react";
import { Col, Form, Row } from "react-bootstrap";
import { familyDetailsInitialValues } from "./enum";
import trashIcon from "../../images/red-trash-icon.svg";

const QualificationTable = ({ errors, details, setDetails, loading }) => {
  const handleChange = (index, field, value) => {
    setDetails((prev) => {
      const updatedData = [...prev.data];
      updatedData[index] = {
        ...updatedData[index],
        [field]: value,
      };
      return { ...prev, data: updatedData };
    });
  };

  const columns = [
    {
      title: "",
      dataIndex: "sr_no",
      key: "sr_no",
      // width: 60,
      align: "center",
      render: (text, record, index) => (
        <div className="fw-semibold">{index + 1}.</div>
      ),
    },
    {
      title: (
        <span>
          Examination Name <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_name",
      key: "itl_name",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            value={text}
            placeholder="Examination Name"
            className={`${errors[index]?.itl_name ? "error" : ""}`}
            onChange={(e) => handleChange(index, "itl_name", e.target.value)}
            disabled={loading}
          />
          <div className="input-error">{errors[index]?.itl_name}</div>
        </div>
      ),
    },
    {
      title: (
        <span>
          Year <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_year",
      key: "itl_year",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            type="number"
            value={text}
            placeholder="Year"
            className={`${errors[index]?.itl_year ? "error" : ""}`}
            onChange={(e) => handleChange(index, "itl_year", e.target.value)}
            disabled={loading}
          />
          <div className="input-error">{errors[index]?.itl_year}</div>
        </div>
      ),
    },
    {
      title: (
        <span>
          Institute Name <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_institutename",
      key: "itl_institutename",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            value={text}
            placeholder="Institute Name"
            className={`${errors[index]?.itl_institutename ? "error" : ""}`}
            onChange={(e) =>
              handleChange(index, "itl_institutename", e.target.value)
            }
            disabled={loading}
          />
          <div className="input-error">{errors[index]?.itl_institutename}</div>
        </div>
      ),
    },
    {
      title: (
        <span>
          % / CGPA Obtained <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_marksobtained",
      key: "itl_marksobtained",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            value={text}
            placeholder="% / CGPA Obtained"
            className={`${errors[index]?.itl_marksobtained ? "error" : ""}`}
            onChange={(e) =>
              handleChange(index, "itl_marksobtained", e.target.value)
            }
            disabled={loading}
          />
          <div className="input-error">{errors[index]?.itl_marksobtained}</div>
        </div>
      ),
    },
  ];

  const handleDelete = (index) => {
    setDetails((prev) => {
      const updatedData = [...prev.data];
      const deletedItem = updatedData[index];
      updatedData.splice(index, 1);

      const updatedDeletedData = [...prev.deletedData];
      if (deletedItem?.itl_qualificationid) {
        updatedDeletedData.push(deletedItem.itl_qualificationid);
      }

      return {
        ...prev,
        data: updatedData,
        deletedData: updatedDeletedData,
      };
    });
  };

  const handleAddNewRow = () => {
    setDetails((prev) => ({
      ...prev,
      data: [...prev.data, { ...familyDetailsInitialValues }],
    }));
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-end mb-3">
        <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-end gap-1 gap-lg-2">
          <h5 className="mb-0">Qualification </h5>
          <div className="custom-font-size">(Recent on top / Minimum two)</div>
        </div>
      </div>

      <hr />
      <div className="d-none d-lg-block">
        <Table
          size="small"
          columns={columns}
          dataSource={details.data}
          pagination={false}
          scroll={{ x: "max-content" }}
          className="custom-candidate-form-table"
        />
      </div>

      {/* Mobile view */}
      <div className="d-lg-none">
        {details.data.map((item, index) => (
          <div key={index} className="">
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="required fw-semibold">
                    {index + 1}. Examination Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Examination Name"
                    value={item.itl_name}
                    className={`${errors[index]?.itl_name ? "error" : ""}`}
                    onChange={(e) =>
                      handleChange(index, "itl_name", e.target.value)
                    }
                    disabled={loading}
                  />
                  <div className="input-error">{errors[index]?.itl_name}</div>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="required fw-semibold">Year</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Year"
                    value={item.itl_year}
                    className={`${errors[index]?.itl_year ? "error" : ""}`}
                    onChange={(e) =>
                      handleChange(index, "itl_year", e.target.value)
                    }
                    disabled={loading}
                  />
                  <div className="input-error">{errors[index]?.itl_year}</div>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="required fw-semibold">
                    Institute Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Institute Name"
                    value={item.itl_institutename}
                    className={`${errors[index]?.itl_institutename ? "error" : ""
                      }`}
                    onChange={(e) =>
                      handleChange(index, "itl_institutename", e.target.value)
                    }
                    disabled={loading}
                  />
                  <div className="input-error">
                    {errors[index]?.itl_institutename}
                  </div>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="required fw-semibold">
                    % / CGPA Obtained
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="% / CGPA Obtained"
                    value={item.itl_marksobtained}
                    className={`${errors[index]?.itl_marksobtained ? "error" : ""
                      }`}
                    onChange={(e) =>
                      handleChange(index, "itl_marksobtained", e.target.value)
                    }
                    disabled={loading}
                  />
                  <div className="input-error">
                    {errors[index]?.itl_marksobtained}
                  </div>
                </Form.Group>
              </Col>
            </Row>
            {index < details.data.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QualificationTable;
